import {
  arrayField,
  numberField,
  objectField,
  stringList,
} from "./parseFields";
import type {
  ComplianceApprovedImage,
  ComplianceApprovalResult,
  PromotableService,
} from "./types";

export function approvedImagesFromServices(
  services: PromotableService[],
): ComplianceApprovedImage[] | null {
  const images: ComplianceApprovedImage[] = [];
  for (const service of services) {
    const serviceName = service.name.trim();
    const imageDigest = service.imageDigest.trim();
    if (!serviceName || !imageDigest) {
      return null;
    }
    images.push({ serviceName, imageDigest });
  }
  return images;
}

export function approvalResultIssues(
  result: ComplianceApprovalResult | null,
): string[] {
  if (!result) {
    return [];
  }
  return [...result.errors, ...result.dbConfigErrors].filter(Boolean);
}

export function parseComplianceApproval(
  payload: unknown,
): ComplianceApprovalResult | null {
  if (payload == null || typeof payload !== "object") {
    return null;
  }
  const record = payload as Record<string, unknown>;
  const nested = objectField(record, "data") ?? record;
  return {
    updatedCount: numberField(nested, "updatedCount", "updated_count"),
    updatedServices: stringList(
      arrayField(nested, "updatedServices", "updated_services"),
    ),
    errors: stringList(arrayField(nested, "errors")),
    updatedDbConfigs: stringList(
      arrayField(nested, "updatedDbConfigs", "updated_db_configs"),
    ),
    dbConfigErrors: stringList(
      arrayField(nested, "dbConfigErrors", "db_config_errors"),
    ),
  };
}
